var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container lnb d_container"},[_c('div',{staticClass:"contents_wrap"},[_c('div',{staticClass:"contents list-container"},[_c('div',{staticClass:"title"},[_vm._v(" 삭제 아이템 ")]),_c('div',[_c('item-list-component',{attrs:{"item-type":`deleteList`}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }